/** Build-time configuration. Every VITE_* value is public and ships in the bundle. */
export const API_HOST: string = import.meta.env.VITE_API_HOST || `${location.hostname}:8793`
export const API_SECURE: boolean = import.meta.env.VITE_API_HOST ? true : location.protocol === 'https:'
export const BUILD: string = import.meta.env.VITE_BUILD || 'dev'
